import { SHIPMENT_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const shipmentRoute = (): RouteRecordRaw => ({
  path: 'shipment/:orderId',
  name: SHIPMENT_ROUTE_NAME.SHIPMENT_MANAGE,
  component: () => import('@/pages/manage/shipment/index.vue'),
});

export const shipmentDetailRoute = (): RouteRecordRaw => ({
  path: 'shipment/:orderId/detail',
  name: SHIPMENT_ROUTE_NAME.SHIPMENT_DETAIL,
  component: () => import('@/pages/manage/shipment/detail.vue'),
});

export const shipmentListRoute = (): RouteRecordRaw => ({
  path: 'shipments',
  name: SHIPMENT_ROUTE_NAME.SHIPMENT_LIST,
  component: () => import('@/pages/manage/shipment/list.vue'),
});
